import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import IndustryPage from "@/pages/IndustryPage";

export const Route = createFileRoute("/en/industries/in-vitro-diagnostics/")({
  head: () => buildRouteHead("/en/industries/in-vitro-diagnostics"),
  component: IndustryPage,
});

